import { useMemo } from 'react'
import { FeriadoResponsePaginate } from 'core/features/feriados/typings'
import moment from 'moment'
import { Tag } from '@chakra-ui/react'

function useFeriadosColumns(ano: string) {
  return useMemo(() => {
    return [
      {
        title: 'Data',
        render: (item: FeriadoResponsePaginate) => {
          return `${item.dia}/${item.mes}`
        }
      },
      {
        title: 'Descrição',
        dataIndex: 'nome'
      },
      {
        title: 'Dia da semana',
        render: (item: FeriadoResponsePaginate) => {
          return moment(`${ano}-${item.mes}-${item.dia}`).format('dddd')
        }
      },
      {
        title: '',
        render: (item: FeriadoResponsePaginate) => {
          if (item.padrao) {
            return <Tag colorScheme="green">Nacional</Tag>
          }

          return null
        }
      }
    ]
  }, [ano])
}

export default useFeriadosColumns
